import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const auth = createReducer(
  {
    versionMisMatch: false,
  },
  {
    [types.LOGIN_USER_START](state) {
      const newState = Object.assign({}, state, {
        userid: null,
        isLoggedIn: false,
        isLoginFail: false,
        isLoggedOut: false,
        isNotRegistered: false,
        isUnsubscribed: false,
        isServerError: false,
        isLoggingIn: true,
        isLoggingOut: false,
        isValidating: false,
        isValidCSuser: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.LOGIN_USER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        userid: action.userObj.user,
        domain: action.userObj.domain,
        subscription_status: action.userObj.subscription_status,
        features: action.userObj.features,
        domain_keywords: action.userObj.domain_keywords,
        booking_software: action.userObj.booking_software,
        brand_ids: action.userObj.brand_ids,
        studio_id: action.userObj.studio_id,
        studio_name: action.userObj.studio_name,
        is_brand: action.userObj.is_brand,
        role: action.userObj.role,
        is_phone_assigned: action.userObj.is_phone_assigned,
        dashboard_settings: action.userObj.dashboard_settings,
        weave_phone: action.userObj.weave_phone,
        isLoggedIn: true,
        isLoginFail: false,
        isLoggingIn: false,
      });

      return newState;
    },
    [types.LOGIN_USER_ERROR](state) {
      const newState = Object.assign({}, state, {
        isLoggedIn: false,
        isLoginFail: true,
        isLoggingIn: false,
      });

      return newState;
    },
    [types.LOGIN_USER_INTERNAL_ERROR](state) {
      const newState = Object.assign({}, state, {
        isServerError: true,
        isLoggingIn: false,
      });

      return newState;
    },
    [types.LOGIN_USER_UNSUBSCRIBED](state, action) {
      const newState = Object.assign({}, state, {
        isUnsubscribed: true,
        isLoggingIn: false,
        errorMessage: action.message,
      });

      return newState;
    },
    [types.LOGIN_USER_NOT_REGISTERED](state, action) {
      const newState = Object.assign({}, state, {
        isNotRegistered: true,
        isLoggingIn: false,
        errorMessage: action.message,
      });

      return newState;
    },
    [types.REGISTER_USER_START](state) {
      const newState = Object.assign({}, state, {
        userid: null,
        isLoggedIn: false,
        isLoginFail: false,
        isLoggedOut: false,
        isRegisterUserFail: false,
        isRegistered: false,
        isRegistering: true,
        errorMessage: null,
      });

      return newState;
    },
    [types.REGISTER_USER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        userid: action.userObj.user,
        isLoggedIn: true,
        isRegistered: true,
        isRegistering: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.REGISTER_USER_ERROR](state, action) {
      const newState = Object.assign({}, state, {
        userid: null,
        isRegisterUserFail: true,
        isRegistering: false,
        errorMessage: action.errormessage,
      });

      return newState;
    },
    [types.UNAUTHORIZED_ACCESS](state) {
      const newState = Object.assign({}, state, {
        userid: null,
        isLoggedIn: false,
      });

      return newState;
    },
    [types.FORGOT_PASSWORD_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        forgotPasswordRequestAccepted: true,
      });

      return newState;
    },
    [types.FORGOT_PASSWORD_ERROR](state) {
      const newState = Object.assign({}, state, {
        forgotPasswordRequestAccepted: false,
      });

      return newState;
    },
    [types.GET_FORGOT_PASSWORD_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        forgotPasswordRequestVerify: true,
      });

      return newState;
    },
    [types.GET_FORGOT_PASSWORD_ERROR](state) {
      const newState = Object.assign({}, state, {
        forgotPasswordRequestVerify: false,
      });

      return newState;
    },
    [types.POST_RESET_PASSWORD_START](state) {
      const newState = Object.assign({}, state, {
        saveResetPassword: null,
      });

      return newState;
    },
    [types.POST_RESET_PASSWORD_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        saveResetPassword: true,
      });

      return newState;
    },
    [types.POST_RESET_PASSWORD_ERROR](state) {
      const newState = Object.assign({}, state, {
        saveResetPassword: false,
      });

      return newState;
    },
    [types.FORGOT_PASSWORD_RESET](state) {
      const newState = Object.assign({}, state, {
        forgotPasswordRequestAccepted: null,
      });

      return newState;
    },
    [types.LOGOUT_START](state) {
      const newState = Object.assign({}, state, {
        user: null,
        isLoggedIn: false,
        isLoggedOut: false,
        isLoggingOut: true,
      });

      return newState;
    },
    [types.LOGOUT_USER](state) {
      const newState = Object.assign({}, state, {
        user: null,
        isLoggedIn: false,
        isLoggedOut: true,
      });

      return newState;
    },
    [types.GET_STRIPE_USER_START](state) {
      const newState = Object.assign({}, state, {
        stripe_user: null,
        getStripeUser: true,
      });

      return newState;
    },
    [types.GET_STRIPE_USER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        stripe_user: action.stripe_user,
        getStripeUser: false,
      });

      return newState;
    },
    [types.GET_STRIPE_USER_FAIL](state) {
      const newState = Object.assign({}, state, {
        stripe_user: null,
        getStripeUser: false,
      });

      return newState;
    },
    [types.VERSION_MISMATCH](state, action) {
      console.log('headers', window.Config.APP_VERSION);
      const newState = Object.assign({}, state, {
        versionMisMatch:
          action.headers['x-app-version'] !== window.Config.APP_VERSION,
      });

      return newState;
    },
    [types.VERSION_MISMATCH_FALSE](state) {
      const newState = Object.assign({}, state, {
        versionMisMatch: false,
      });

      return newState;
    },
    [types.VALIDATE_CS_USER_START](state) {
      const newState = Object.assign({}, state, {
        isValidating: true,
        isValidCSuser: false,
      });

      return newState;
    },
    [types.VALIDATE_CS_USER_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        isValidating: false,
        isValidCSuser: true,
      });

      return newState;
    },
    [types.VALIDATE_CS_USER_FAIL](state) {
      const newState = Object.assign({}, state, {
        isValidating: false,
        isValidCSuser: false,
      });

      return newState;
    },
  },
);
export { auth as default };
